import { ArrayBase } from '../ArrayBase';

export class BehavioralInterest extends ArrayBase {}
